// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEnquiry_root__19tqa","marketplaceColorStroke":"IconEnquiry_marketplaceColorStroke__2RLlA"};